// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2EpAl","productName":"Table_productName__J3o4x"};